export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-female-5165ec23d48bdb5ae6276110a9640d5f.svg";